import { render, staticRenderFns } from "./SchoolRun.vue?vue&type=template&id=e113c7f2&"
import script from "./SchoolRun.vue?vue&type=script&lang=js&"
export * from "./SchoolRun.vue?vue&type=script&lang=js&"
import style0 from "./SchoolRun.vue?vue&type=style&index=0&id=e113c7f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports